import { Box, BoxProps, Image } from '@chakra-ui/react';
import { Link, Outlet } from 'react-router-dom';
import { BaseNav, useAuth, useNavItemStore } from '@cksoftware/react-base';
import logo from '../../assets/logo.png';
import { ConductionAuctionButton } from '../../features/header/components/conductionAuctionButton';
import { useProfileItems } from './useProfileItems';
import { DlmsUser, getCurrentProfile } from '../../globalModels/user/dlmsUser';

type NarrowLayoutProps = {
  containerProps?: BoxProps;
};

export const Layout = (props: NarrowLayoutProps) => {
  const routeNav = useNavItemStore((state) => {
    return { items: state.getDefault(), get: state.get };
  });

  const auth = useAuth<DlmsUser>();
  const profileItems = useProfileItems();
  const currentProfile = getCurrentProfile(auth.user);

  return (
    <Box as='section' width='100vw' height='100vh' overflowY='auto'>
      <BaseNav.Header
        navItems={routeNav.items}
        profileItems={profileItems}
        avatarName={`${currentProfile?.FirstName} ${currentProfile?.LastName}`}
        logo={
          <Link to={'/'}>
            <Image height={['65px']} src={logo} alt='logo' />
          </Link>
        }>
        <ConductionAuctionButton />
      </BaseNav.Header>

      <Box
        w={['100%', '100%', '100%', '90%']}
        margin={'auto'}
        paddingLeft={'5px'}
        paddingRight={'5px'}
        paddingTop={'10px'}
        {...props.containerProps}>
        <Outlet />
      </Box>
    </Box>
  );
};
